export default "__VITE_ASSET__DM14ThJZ__"